import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'
import { db } from '@/firebase'
// import { vuexfireMutations, firestoreAction } from 'vuexfire'
Vue.use(Vuex)

const state = {    
  user: null,
  test: null
}

const getters = {
  user(state){
    return state.user    
  }
}

const mutations = {
  setUser(state, user) {
    state.user = user
  },
}

const actions = {
  updateUser({ commit }, user){
    commit("setUser", user)
  },
  newUserDB({ state },{ uid, displayName }){
    state.test = null
    const params = {        
      username: displayName,    
      uid: uid,    
      win: false,        
    }
    db.collection('users').doc(uid).set(params)
  },
  isCreatedUserDB({ state }, uid ){
    state.test = null
    db.collection('users').doc(uid).get()
      .then(res => {
        return res.exists
      })
  },  
  signUpAndLogIn({ dispatch }){      
    const provider = new firebase.auth.GoogleAuthProvider()
    firebase.auth().signInWithPopup(provider)
      .then( res =>{                                                 
        const uid = res.user.uid
        const displayName = res.user.displayName        
        dispatch('isCreatedUserDB', res.user.uid)
          .then( val => {
            if ( !val ){
              dispatch('newUserDB',{ uid, displayName })
            }            
          })           
      })
      .catch( err =>{        
        alert(err.message)
      })    
  },
  signOut(){
    firebase.auth().signOut()
  },       
}
const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})
export default store

firebase.auth().onAuthStateChanged( user => {
  if( user ){          
    // in firestore, search user's info
    db.collection("users").where("uid", "==", user.uid)
      .onSnapshot(snapshot => {  
        snapshot.forEach(doc => {     
          const user = doc.data()
          store.dispatch("updateUser", user)
        });                       
      },err => {
        alert(err.message)
      })                  
  } else {
    store.dispatch("updateUser", null)        
  }      
})